import React, { useEffect } from 'react';
import { InstructionWrapper, TextField } from '../../../../components/fields';
import Form from '../../../../components/form/Form';
import Heading from '../../../../_global/components/heading/Heading';
import { publish, useStateReducer } from '../../../../hooks';
import { StateTopicEnum } from '../../../../enums';
import { validateObject } from '../../../../utilities';
import { Regexes } from '../../../../definitions';
import { ISubscriptionTiers } from '../../types';

interface IEditSubscriptionsProps {
  data: ISubscriptionTiers;
}

const EditSubscriptions = ({ data }: IEditSubscriptionsProps) => {
  const { _id, tier, hotelSearchLimit, flightSearchLimit } = data;
  const [state, setState] = useStateReducer({
    _id,
    tier,
    hotelSearchLimit,
    flightSearchLimit
  });

  const handleSearchLimit = (
    target: EventTarget & (HTMLInputElement | HTMLTextAreaElement)
  ) => {
    if (!target.name) return;
    const value = !target.value.length ? null : parseInt(target.value);
    const name = target.name;
    setState({ [name]: value });
  };

  const errors = validateObject(
    {
      hotelSearchLimit: {
        regex: Regexes.positiveInt,
        message: 'Hotel Search limit is required.'
      },
      flightSearchLimit: {
        regex: Regexes.positiveInt,
        message: 'Hotel Search limit is required.'
      }
    },
    state
  );

  const isValid = () => {
    if (errors['hotelSearchLimit']) return false;
    if (errors['flightSearchLimit']) return false;
    return true;
  };

  useEffect(() => {
    publish(StateTopicEnum.IsValid, isValid());
    publish(StateTopicEnum.EditSubscription, { ...state });
    // eslint-disable-next-line
  }, [state.hotelSearchLimit, state.flightSearchLimit]);

  return (
    <div id='role-view-item' className='read-only'>
      <Heading name={data.tier} />
      <Form title='Hotel Search limit'>
        <InstructionWrapper text='Limit for hotel searches' row>
          <TextField
            placeholder='Limit'
            label='Limit'
            name='hotelSearchLimit'
            value={state.hotelSearchLimit}
            onChange={({ target }) => handleSearchLimit(target)}
          />
        </InstructionWrapper>
      </Form>
      <Form title='Flight Search limit'>
        <InstructionWrapper text='Limit for flight searches' row>
          <TextField
            placeholder='Limit'
            label='Limit'
            name='flightSearchLimit'
            value={state.flightSearchLimit}
            onChange={({ target }) => handleSearchLimit(target)}
          />
        </InstructionWrapper>
      </Form>
    </div>
  );
};

export default EditSubscriptions;
